<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<blockquote epub:type="epigraph" role="doc-epigraph">
<p class="EP" id="epi"><span aria-label="xi" id="pg_xi" role="doc-pagebreak">“Each human life must work through all the joys and sorrows, gains and losses, which make up the history of the world.”</span></p>
<p class="EPC"><span class="small">THOMAS MANN</span></p>
<blockquote epub:type="epigraph" role="doc-epigraph">
</blockquote>
</blockquote>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?b3e0a1d6